import React from 'react'

interface ColorSquareProps {
  color: string
  size?: 'sm' | 'md' | 'lg'
}

export const ColorSquare: React.FC<ColorSquareProps> = ({
  color,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-md border border-gray-300 flex-shrink-0`}
      style={{ backgroundColor: color }}
    />
  )
}
